import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMoveFolderInside: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconMoveFolderInside"><Path d="M19.207 14.207L17.4141 16H23V18H17.4141L19.207 19.793L17.793 21.207L13.5859 17L17.793 12.793L19.207 14.207Z" fill="currentColor"/><Path d="M12.5352 6H22V14H21.8281L17.793 9.96484L10.7578 17L13.7578 20H2V3H10.5352L12.5352 6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMoveFolderInside;
